import React from "react";
import {useCurrentUser} from "_api/hooks/auth";
import {RegisterTwoFactor} from "./components/RegisterTwoFactor";
import {TwoFactorEnabled} from "./components/TwoFactorEnabled";

export const Security = () => {
    const {user: {twoFactorEnabled}} = useCurrentUser();
    return twoFactorEnabled
        ? <TwoFactorEnabled/>
        : <RegisterTwoFactor/>

};
